export const ProductReducerInitialState = {
  productsById: {},
  productVariantGroupsById: {},
  productRulesById: {},
  previouslyOrderedProducts: [],
  productSearchTotals: {},
};
